import React from "react";
import LoadingIndicator from "./components/LoadingIndicator";
import AppMessage from './components/AppMessage'
import WorkFlow from './modules/workflow/components/WorkFlow'

function App(props) {
  return (
    <>
      {props.children}

      <LoadingIndicator />
      <AppMessage />
      <WorkFlow />
    </>
  );
}
export default App;
